import { Flex } from 'antd';
import { ContentContainer } from '../../assets/styles/components/onboardContent.styled';
import { Heading, Paragraph } from '../Ant';

interface OnboardContentProps {
  icon?: React.ReactNode;
  title: string;
  subtitle?: string;
  children?: React.ReactNode;
}

const OnboardContent = ({ icon, title, subtitle, children }: OnboardContentProps) => {
  return (
    <ContentContainer vertical align="center" justify="center" gap={10}>
      {icon}
      <Flex vertical gap={5} align="center" justify="center">
        <Heading
          level={6}
          $fontsize="16px"
          $lineheight="22px"
          $weight={600}
          $color="title"
          className="ta-center"
        >
          {title}
        </Heading>
        <Paragraph
          $fontsize="13px"
          $lineheight="20px"
          $weight={400}
          $color="description"
          className="ta-center"
        >
          {subtitle}
        </Paragraph>
      </Flex>

      {children}
    </ContentContainer>
  );
};

export default OnboardContent;
